import { Column } from "../CustomDataTable/CustomDataTable";
import { additionalFieldColumns, commonFieldColumns } from "./ContactCommonColumns";
import { FaCheckCircle } from "react-icons/fa";
 

export const SupplierColumns = (props: any): Column[] => [
  ...commonFieldColumns(props),
  {
    field: "contactType",
    headerName: "Supplier Type",
    width: 150,
    defaultChecked: false,
    filtering: true,
  },
  {
    field: "whatsAppNo",
    headerName: "Whatsapp No.",
    width: 150,
    filtering: false,
    defaultChecked: false,
    renderCell: (params: any) =>
    {
      const whatsAppNo = params.row.whatsAppNo;
       
      const prefix =
        params.row.countryDialCodePrefixWhatsapp == 0 
          ? "91"
          : params.row.countryDialCodePrefixWhatsapp;
    //  console.log("whatsAppNo",prefix)
      return whatsAppNo
        ? `+${prefix}-${whatsAppNo}`
        : "";
    }
  },
  {
    headerName: "Bank Name",
    field: "bankName",
    width: 150,
    defaultChecked: false,
  },
  {
    headerName: "Branch Name",
    field: "bankBranch",
    width: 150,
    defaultChecked: false,
  },
  {
    headerName: "Bank Account No.",
    field: "bankAccNo",
    width: 150,
    defaultChecked: false,
  },
  {
    headerName: "IFSC Code",
    field: "bankIfsc",
    width: 150,
    defaultChecked: false,
  },
  // {
  //   field: "totalSupplierOrderValue",
  //   renderCell: (params: any) =>
  //     params.row.totalSupplierOrderValue === ""
  //       ? "-"
  //       : params.row.totalSupplierOrderValue.toFixed(props.sessionList?.decimalPoint || 2),
  //   headerName: "Total Order Value",
  //   width: 200,
  //   defaultChecked: true,
  // },
  // {
  //   field: "totalSupplierOrderCount",
  //   renderCell: (params: any) =>
  //     params.row.totalSupplierOrderCount === ""
  //       ? "-"
  //       : params.row.totalSupplierOrderCount.toFixed(props.sessionList?.decimalPoint || 2),
  //   headerName: "Total Order Count",
  //   width: 230,
  //   defaultChecked: true,
  // },
  // {
  //   field: "totalPayableSuppliers",
  //   headerName: "Supplier Outstanding",
  //   width: 200,
  //   defaultChecked: true,
  //   renderCell: (params: any) =>
  //     params.row.totalPayableSuppliers === ""
  //       ? "-"
  //       : params.row.totalPayableSuppliers.toFixed(props.sessionList?.decimalPoint || 2),
  // },
  {
    field: "active",
    renderCell: (params: any) => (
      <div
        style={{
          color: params.row.active === 0 ? "#00c700" : "#ababab",
        }}
      >
        <FaCheckCircle size={20} />
      </div>
    ),
    headerName: "Status",
    width: 70,
    defaultChecked: true,
    align: "center",
    filtering: true,
    isExisted: (params: any) =>
      params.row.active === 0 ? "Active" : "InActive",
  },
  ...additionalFieldColumns(props),
];